import {Component, Input, OnInit} from '@angular/core';
import {isEmpty} from 'lodash';
import {CommonCustomerAccountService} from '../../api/service';
import {CustomerAccountDetail, CustomerAccountLink} from '../../api/entity';

@Component({
    selector: 'tfl-customer-account-links',
    template: require('./customer-account.links.template.html')
})
export class CustomerAccountLinksComponent implements OnInit {
    @Input('customer-account-id') customerAccountId: number;

    private customerAccount: CustomerAccountDetail;

    changes: { [key: number]: [boolean, boolean]; } = {};

    constructor(private _customersAccountService: CommonCustomerAccountService) {
    }

    ngOnInit(): void {
        this.getAccountById(this.customerAccountId);
    }

    getAccountById(accountId: number) {
        this._customersAccountService.getCustomerAccount(accountId)
            .subscribe(account => this.customerAccount = account);
    }

    isEmptyLinks(): boolean {
        return !this.customerAccount || !this.customerAccount.links || isEmpty(this.customerAccount.links);
    }

    isOptionsChanged(link: CustomerAccountLink) {
        let linkOptions: [boolean, boolean] = this.changes[link.id];
        if (linkOptions) {
            return link.allowIncoming !== linkOptions[0]
                || link.allowOutgoing !== linkOptions[1];
        }
        return false;
    }

    isIncoming(link: CustomerAccountLink) {
        let linkOptions: [boolean, boolean] = this.changes[link.id];
        if (linkOptions) {
            return linkOptions[0];
        }
        return link.allowIncoming;
    }

    isOutgoing(link: CustomerAccountLink) {
        let linkOptions: [boolean, boolean] = this.changes[link.id];
        if (linkOptions) {
            return linkOptions[1];
        }
        return link.allowOutgoing;
    }

    changeIncoming(link: CustomerAccountLink) {
        this.changes[link.id] = [!this.isIncoming(link), this.isOutgoing(link)];
        if (!this.isOptionsChanged(link)) {
            this.changes[link.id] = undefined;
        }
    }

    changeOutgoing(link: CustomerAccountLink) {
        this.changes[link.id] = [this.isIncoming(link), !this.isOutgoing(link)];
        if (!this.isOptionsChanged(link)) {
            this.changes[link.id] = undefined;
        }
    }

    saveChanges(link: CustomerAccountLink) {
        let incoming = this.isIncoming(link);
        let outgoing = this.isOutgoing(link);
        this._customersAccountService.saveCustomerToLiquidityAccountLinkOptions(this.customerAccount.id, link.liquidityAccountId, incoming, outgoing)
            .subscribe(response => {
                link.allowIncoming = response.allowIncoming;
                link.allowOutgoing = response.allowOutgoing;
                this.changes[link.id] = undefined;
            }, error => {throw error; });
    }

    isAnyOptionChanged(): boolean {
        let oneOfChangedLinks: CustomerAccountLink  = this.customerAccount.links.find((link: CustomerAccountLink) => this.isOptionsChanged(link));
        return oneOfChangedLinks !== null && oneOfChangedLinks !== undefined;
    }

    saveAllChanges() {
        this.customerAccount.links.forEach((link: CustomerAccountLink) => {
           if (this.isOptionsChanged(link)) {
               this.saveChanges(link);
           }
        });
    }

    resetAllChanges() {
        this.customerAccount.links.forEach((link: CustomerAccountLink) => this.changes[link.id] = undefined);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/customer-account/customer-account-links/customer-account.links.component.ts